import memoryAxiosInstance from '../../../core/api/memoryAxios';

export const flashcardService = {
  list: async () => {
    const response = await memoryAxiosInstance.get('/flashcards');
    return response.data;
  },
  get: async (
    userUuid: string,
    flashcardUuid: string
  ): Promise<{
    uuid: string;
    front: string;
    back: string;
    decksVinculed: string[];
    tags: Tag[];
    discipline: Tag;
  }> => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/flashcards/${userUuid}/${flashcardUuid}`
    );
    return response.data;
  },
  groupByDiscipline: async (
    userUuid: string
  ): Promise<IGroupedByDisciplineResponse[]> => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/flashcards/${userUuid}/grouped-by-discipline`
    );
    return response.data;
  },
  listByDiscipline: async (
    userUuid: string,
    disciplineUuid: string
  ): Promise<IFlashcardByDisciplineResponse> => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/flashcards/${userUuid}/discipline/${disciplineUuid}`
    );
    return response.data;
  },
  delete: async (userUuid: string, flashcardUuid: string) => {
    const response = await memoryAxiosInstance.delete(
      `/api/v1/flashcards/${userUuid}/delete/${flashcardUuid}`
    );
    return response.data;
  },
  deleteMany: async (userUuid: string, flashcardUuids: string[]) => {
    const response = await memoryAxiosInstance.delete(
      `/api/v1/flashcards/${userUuid}/delete-many`,
      {
        data: { flashcardUuids },
      }
    );
    return response.data;
  },
  addFlashcardToDiscipline: async (
    userUuid: string,
    flashcardUuid: string
  ): Promise<{
    data: { flashcardDeckUuid: string };
    message: string;
  }> => {
    const response = await memoryAxiosInstance.post(
      `/api/v1/flashcards/${userUuid}/add-to-discipline`,
      { flashcardUuid }
    );
    return response.data;
  },
  removeFlashcardFromDeck: async (userUuid: string, flashcardUuid: string) => {
    const response = await memoryAxiosInstance.delete(
      `/api/v1/flashcards/${userUuid}/delete/remove-to-discipline/${flashcardUuid}`
    );
    return response.data;
  },
};
